import { COMPOSER_ROUTES } from '@osmosis/constants';
import { Route } from '../../hooks/useRouterPush';
import { REDIRECT_PARAM } from '../../constants/urls';

/**
 * Parses the legacy routes to a full url.
 * @param route The route number from the COMPOSER_ROUTES.
 * @param oldUrl The old URL to parse.
 * @returns The new URL based on the legacy route and old URL.
 */
export const parseLegacy = (route: number, oldUrl: string): string => {
  const baseRoute = `${COMPOSER_ROUTES[route]}`;
  const parts = oldUrl.split('/').filter(Boolean);

  if (baseRoute === 'root') {
    return `/${parts.join('/')}`;
  }

  return `/${baseRoute}/${parts.join('/')}`;
};

/**
 * Generates the appropriate authentication path based on the destination route.
 * @param destination The destination route to redirect to.
 * @param pathName The current pathname to include in the redirect.
 * @param searchParams The current search parameters to include in the redirect.
 * @returns The create route  or the destination route with the appropriate redirect parameter.
 */
export const getAuthPath = (
  destination: Route,
  pathName: string | null,
  searchParams: URLSearchParams | null,
) => {
  if (destination == Route.CREATE) {
    return (
      destination +
      `?r=${encodeURIComponent(
        (pathName ?? '/') +
          (searchParams ? '?' + searchParams?.toString() : ''),
      )}`
    );
  }

  return (
    Route.LOGIN +
    `?${REDIRECT_PARAM}=${
      encodeURIComponent(pathName ?? '/') +
      (searchParams?.toString() ? '?' + searchParams?.toString() : '')
    }`
  );
};
